<div fxLayout="row" fxLayoutAlign="center" class="m-1">
  <div fxFlex="100" fxFlex.gt-sm="1 1 460px" fxFlex.sm="1 1 460px">
    <div>
      <div fxLayout="row" fxLayoutAlign="space-between center" class="pt-3 pl-3 pr-3 mb-0">
        <h3 class="primary-color m-1">{{ 'TREATMENT.SELECT-TREATMENT-FROM-PRICELIST' | translate }}</h3>
        <button mat-stroked-button (click)="back()">
          <mat-icon matSuffix class="mat-icon-rtl-mirror">navigate_before</mat-icon>
          {{ 'FUTURE-VISITS.BACK' | translate}}
        </button>
      </div>

      <div [formGroup]="form" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutAlign.gt-xs="start center">
        <div class="pb-3" fxLayout="row wrap" fxLayoutAlign="start center">

          <mat-radio-group formControlName="options">
            <mat-radio-button value="treatment" color="primary" class="m-2" [disabled]="hasTreatmentsFromSeries">{{ 'TREATMENT.TREATMENTS' | translate }}
            </mat-radio-button>
            <mat-radio-button value="series" color="primary" [disabled]="!hasTreatmentsFromSeries && totalSelected() > 0">{{ 'TREATMENT.SERIES' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>

        <div class="m-1 p-3 mat-elevation-z6">
          <div fxFlex="100" fxLayout='column'>
            <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
              <div fxFlex="60" class="p-1" *ngIf="form.get('options').value === 'treatment'">
                <mat-form-field class="w-100">
                  <input matInput placeholder="{{ 'TREATMENT.SEARCH-CODE-OR-ITEM' | translate }}"
                    formControlName="search" aria-label="search">
                  <mat-icon matSuffix>search</mat-icon>
                  <mat-icon *ngIf="false" matIcon matSuffix (click)="form.get('search').setValue('')">clear</mat-icon>
                </mat-form-field>
              </div>

              <div fxFlex="60" class="p-1" *ngIf="form.get('options').value === 'series'" class="primary-color">
                {{ 'TREATMENT.SERIES-MSG' | translate }}
              </div>

              <div fxFlex="35" class="p-1">
                <mat-form-field class="w-100">
                  <mat-select placeholder="{{ 'TREATMENT.PRICELIST' | translate }}" formControlName="pricelist">
                    <mat-option *ngFor="let currentPricelist of priceLists" [value]="currentPricelist.ID">
                      {{currentPricelist.Name}} </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div fxFlex fxFlexLayout="column">

              <div *ngIf="form.value.options === 'treatment'" fxLayout="row" fxLayoutAlign="space-between center">
                <div fxFlex="25" class="primary col">{{ 'TREATMENT.CODE' | translate }}</div>
                <div fxFlex="25" class="primary col">{{ 'TREATMENT.NAME' | translate }}</div>
                <div fxFlex="25" class="primary col">{{ 'TREATMENT.PRICE' | translate }}</div>
                <div fxFlex="25">&nbsp;</div>
              </div>

              <div *ngIf="form.value.options === 'series'" fxLayout="row" fxLayoutAlign="space-between center">
                <div fxFlex="20" class="primary col">{{ 'TREATMENT.CODE' | translate }}</div>
                <div fxFlex="20" class="primary col">{{ 'TREATMENT.NAME' | translate }}</div>
                <div fxFlex="20" class="primary col">{{ 'TREATMENT.AMOUNT' | translate }}</div>
                <div fxFlex="20" class="primary col">{{ 'TREATMENT.PRICE' | translate }}</div>
                <div fxFlex="20">&nbsp;</div>
              </div>


              <div class="container" [ngClass]="{ 'treatments': form.value.options === 'treatment' }">
                <div *ngFor="let codeItem of (priceListCodes | pricelistCodeFilter: form.get('search').value); let index=index; let odd=odd; let even=even;">

                  <app-pricelist-code-row *ngIf="form.value.options === 'treatment'" [priceListCode]="codeItem"
                    [odd]="odd" [even]="even">
                  </app-pricelist-code-row>

                  <app-pricelist-series-row *ngIf="form.value.options === 'series'" [priceListCode]="codeItem"
                    [odd]="odd" [even]="even">
                  </app-pricelist-series-row>
                </div>
              </div>

              <div *ngIf="form.value.options === 'treatment'" class="mt-2">
                <button mat-raised-button color="primary" class="w-100 ok-button mt-2" [disabled]="!hasSelectedItems()"
                  (click)="onOK()">
                  <div fxLayout="row" fxLayoutAlign="space-around center">
                    <span style="font-size: 1.5em;">{{ 'COMMON.OK' | translate }}</span>
                    <span>{{ 'FIND-TIME.X-TREATMENT-SELECTED' | translate: { total: totalSelected() } }}</span>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>